import type { FaireProductEntity } from "../../entity_types/product";

export const p_vkdf6v6cwd: FaireProductEntity = {
  token: "p_vkdf6v6cwd",
  type: "product",
  name: "Golf Sweater for Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/b687f0e1a0cee8188a0fbb7ea72fd756146fbe16884994f01be0ed0f3c1f4414.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c3838b3626d1ece595723a5524c85df0da886aece5afc0a82d392c1f610c47f.png",
  ],
  priceDollars: 24,
  description:
    "A perfect pick for future little golfers, this hand‑knit sweater showcases a golf ball perched on a tee, surrounded by greens and a pin for a playful course‑side look. Knit in soft, chunky yarn, it features cozy raglan sleeves accented with a classic cable detail, adding texture and charm to this sporty style.\n\n\n\nOur sweaters are crafted using recycled, sustainable polyester yarn spun from reclaimed plastic bottles, a thoughtful choice that helps lessen global plastic waste. It’s one small way we’re contributing to a cleaner, more sustainable world. ♻️\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio\n",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:51.433Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
